import React, { Component } from "react";
import TaskIcon from "../Commands/TaskIcon/TaskIcon";
import FormIcon from "../Commands/FormIcon/FormIcon";
import WorkFlowIcon from "../Commands/WorkFlowIcon/WorkFlowIcon";
import ValidationIcon from "../Commands/ValidationIcon/ValidationIcon";
import AlertIcon from "../Commands/AlertIcon/AlertIcon";
import DashBoardIcon from "../Commands/DashBoardIcon/DashBoardIcon";
import PolicyIcon from "../Commands/PolicyIcon/PolicyIcon";
import "./SideBar.css";

const SideBar = props => {
  return (
    
    <nav className="sidebar" style = {{ width: props.width, height: props.height }}>
      <ul>
        <li>
          <a href="/">
            <TaskIcon />
            <span>Tasks</span>
          </a>
        </li>
        <li>
          <a href="/">
            <FormIcon />
            <span>Form</span>
          </a>
        </li>
        <li>
          <a href="/">
            <WorkFlowIcon />
            <span>WorkFlow</span>
          </a>
        </li>
        <li>
          <a href="/">
            <ValidationIcon />
            <span>Validations</span>
          </a>
        </li>
        <li>
          <a href="/">
            <AlertIcon />
            <span>Alerts</span>
          </a>
        </li>
        <li>
          <a href="/">
            <PolicyIcon />
            <span>Policy</span>
          </a>
        </li>
        <li>
          <a href="/">
            <DashBoardIcon />
            <span>DashBoard</span>
          </a>
        </li>
      </ul>
    </nav>
  );
};

export default SideBar;
